import moment from "moment";
import getDayRangeString from "./day-range-string";
import { DATE_FORMATS, PERIOD_FORMATS } from "../constants";

const { DATE_PICKER_FORMAT } = DATE_FORMATS;

const LARGE_SCREEN = process.browser && window && window.innerWidth > 1368;

export const getChartLabels = (keys, query, period) => {
  const period_short = PERIOD_FORMATS[period];
  return keys.map((key) => {
    // Larger screens get a formatted date as a label
    if (LARGE_SCREEN) {
      const date = moment.utc(query.start, DATE_PICKER_FORMAT).add(key, period);
      return getDayRangeString(
        [date, date.clone().add(1, period).subtract(1, "day")],
        query,
        false
      );
    }
    // Smaller screens get the previously used labels (D1, M1, W1 and so on)
    return `${period_short}${key + 1}`;
  });
};
